module.exports = __webpack_public_path__ + "static/media/bg-2.2398eb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tocollege/bg-2.png
// module id = 220
// module chunks = 0